import React from "react";
import { NavLink } from "react-router-dom";
import NativeInterface from "../../services/NativeInterface"
import AuthContext from '../../store/AuthContext';

import { BsSearch, BsBookmarksFill } from 'react-icons/bs';
import { BiSolidCamera } from 'react-icons/bi';
import { FaUser } from 'react-icons/fa';
import { LuCog } from "react-icons/lu";

import { IoHomeOutline, IoHomeSharp } from "react-icons/io5";
import { BsInfoCircle, BsFillInfoCircleFill } from 'react-icons/bs';
import { IoMap, IoMapOutline } from "react-icons/io5";
import { IoPersonOutline, IoPersonSharp } from "react-icons/io5";
import { useLanguage } from "pages/dimension/LanguageContext";

import "./FooterMobile.css";

const FooterMobile: React.FC = () => {
    const authCtx = React.useContext(AuthContext);
    const langCtx = useLanguage();
/*
    function qrcodeClickHandler() {
        NativeInterface.launchNativeApp({scan: 1});
    }
*/
    function handleLiveView() {
        NativeInterface.launchNativeApp({});
    }

    return (
        <div className="mobile-footer-main">
            <NavLink to="/" className="mobile-nav-item" end>
                {({ isActive }) => (
                    <>
                        {isActive ? <IoHomeSharp /> : <IoHomeOutline />}
                        <span>{langCtx.translate('Home')}</span>
                    </>
                )}
            </NavLink>
            <NavLink to="/info" className="mobile-nav-item">
                {({ isActive }) => (
                    <>
                        {isActive ? <BsFillInfoCircleFill /> : <BsInfoCircle />}
                        <span>{langCtx.translate('Info')}</span>
                    </>
                )}
            </NavLink>
            {NativeInterface.isPWA() && (
                <div className="mobile-nav-item middle" onClick={handleLiveView}>
                    <div className="camera-btn">
                        <BiSolidCamera className="camera-icon"/>
                    </div>
                </div>
            )}
            <NavLink className="mobile-nav-item" to="/map">
                {({ isActive }) => (
                    <>
                        {isActive ? <IoMap /> : <IoMapOutline />}
                        <span>{langCtx.translate('Map')}</span>
                    </>
                )}
            </NavLink>
            <NavLink className={`mobile-nav-item ${authCtx.account.valid() ? "" : "text-warning"}`} to="/account">
                {({ isActive }) => (
                    <>
                        {isActive ? <IoPersonSharp /> : <IoPersonOutline />}
                        <span>{authCtx.account.valid() ? langCtx.translate("Profile") : langCtx.translate("Log In")}</span>
                    </>
                )}
            </NavLink>
        </div>
    );
};

export default FooterMobile;
